/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { ToolMetadata, ToolMetadata$inboundSchema } from "./toolmetadata.js";

/**
 * Result of a strictly additive tool metadata batch insert.
 */
export type AddToolMetadataBatchResult = {
  /**
   * The tool metadata entries created by this call
   */
  tools: Array<ToolMetadata>;
};

/** @internal */
export const AddToolMetadataBatchResult$inboundSchema: z.ZodMiniType<
  AddToolMetadataBatchResult,
  unknown
> = z.object({
  tools: z.array(ToolMetadata$inboundSchema),
});

export function addToolMetadataBatchResultFromJSON(
  jsonString: string,
): SafeParseResult<AddToolMetadataBatchResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AddToolMetadataBatchResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AddToolMetadataBatchResult' from JSON`,
  );
}
